/* Gold Medal Awards & Apparel — theme.js */
(function () {
  'use strict';

  var routes = { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js' };

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      mobileNav.hidden = !isOpen;
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartCloseEls = document.querySelectorAll('[data-cart-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (cartToggle) cartToggle.addEventListener('click', openDrawer);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Cart count / drawer refresh ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartDrawer() {
    fetch('/cart')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh && drawer) {
          drawer.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  }

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateCartCount(cart.item_count); })
    .catch(function () {});

  /* ---------- Order notes (cart drawer) ---------- */
  function saveCartNote(value) {
    return fetch(routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    });
  }

  document.addEventListener('change', function (e) {
    var noteField = e.target.closest('[data-cart-note]');
    if (noteField) saveCartNote(noteField.value);
  });

  // Make sure a note typed in the drawer is saved before going to checkout.
  document.addEventListener('click', function (e) {
    var checkoutLink = e.target.closest('[data-cart-checkout]');
    if (!checkoutLink) return;
    var noteField = document.querySelector('[data-cart-drawer] [data-cart-note]');
    if (!noteField) return;
    e.preventDefault();
    var href = checkoutLink.getAttribute('href');
    saveCartNote(noteField.value).then(function () {
      window.location.href = href;
    }).catch(function () {
      window.location.href = href;
    });
  });

  /* ---------- Add to cart (product form) ---------- */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = productForm.querySelector('[data-add-to-cart]');
      var textEl = productForm.querySelector('[data-add-to-cart-text]');
      var originalText = textEl ? textEl.textContent : '';
      if (submitBtn) submitBtn.disabled = true;
      if (textEl) textEl.textContent = 'Adding…';

      var formData = new FormData(productForm);

      fetch(routes.cartAdd, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) { throw new Error(data.description || data.message || 'Could not add to cart'); }
            return data;
          });
        })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (textEl) textEl.textContent = 'Added';
          openDrawer();
          refreshCartDrawer();
          setTimeout(function () {
            if (textEl) textEl.textContent = originalText;
            if (submitBtn) submitBtn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          if (textEl) textEl.textContent = 'Could not add — try again';
          setTimeout(function () {
            if (textEl) textEl.textContent = originalText;
            if (submitBtn) submitBtn.disabled = false;
          }, 2500);
        });
    });
  }

  /* ---------- Quantity steppers (product page) ---------- */
  document.querySelectorAll('.quantity-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  /* ---------- Cart drawer line quantity changes ---------- */
  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-qty-increase], [data-qty-decrease]');
    if (!target) return;
    var line = target.getAttribute('data-line');
    var itemEl = target.closest('[data-cart-line]');
    var qtyEl = itemEl ? itemEl.querySelector('.cart-drawer__item-qty span') : null;
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var next = target.hasAttribute('data-qty-increase') ? current + 1 : Math.max(0, current - 1);

    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: next })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCartDrawer();
      });
  });

  /* ---------- Product media (thumbnails + variant photo switching) ---------- */
  function setActiveMedia(id) {
    var found = false;
    document.querySelectorAll('.product__media-item').forEach(function (item) {
      var match = item.getAttribute('data-media-id') === String(id);
      if (match) found = true;
    });
    if (!found) return;
    document.querySelectorAll('.product__media-item').forEach(function (item) {
      item.classList.toggle('is-active', item.getAttribute('data-media-id') === String(id));
    });
    document.querySelectorAll('[data-media-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-media-thumb') === String(id));
    });
  }

  document.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      setActiveMedia(thumb.getAttribute('data-media-thumb'));
    });
  });

  /* ---------- Variant selection (size / color dropdowns) ---------- */
  var variantDataEl = document.querySelector('[data-product-variants]');
  if (variantDataEl && productForm) {
    var variants = [];
    try { variants = JSON.parse(variantDataEl.textContent); } catch (err) { variants = []; }

    var selects = productForm.querySelectorAll('[data-option-index]');
    var idInput = productForm.querySelector('[data-variant-id]');
    var addBtn = productForm.querySelector('[data-add-to-cart]');
    var addText = productForm.querySelector('[data-add-to-cart-text]');
    var priceEl = document.querySelector('.product__info .price');

    var findVariant = function () {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (v.options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    };

    var applyVariant = function (v, fromUser) {
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;

      if (priceEl) {
        var html = '';
        var onSale = v.compare && v.compare !== v.price && v.compare_cents > v.price_cents;
        if (onSale) html += '<span class="price__compare">' + v.compare + '</span>';
        html += '<span class="price__amount">' + v.price + '</span>';
        priceEl.innerHTML = html;
        priceEl.classList.toggle('price--sale', !!onSale);
      }

      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? 'Add to cart' : 'Sold out';

      if (v.media) setActiveMedia(v.media);

      if (fromUser && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) {}
      }
    };

    selects.forEach(function (select) {
      select.addEventListener('change', function () { applyVariant(findVariant(), true); });
    });

    // Sync once on load so the default variant's photo and price are showing.
    if (selects.length) applyVariant(findVariant(), false);
  }
})();
